import React from 'react';

export const CreditCardIcon = ({ ...props }) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 4.66665H13M3.66667 7.99998H4.33333M7 7.99998H7.66667M3 10.6666H11C12.1046 10.6666 13 9.77122 13 8.66665V3.33331C13 2.22874 12.1046 1.33331 11 1.33331H3C1.89543 1.33331 1 2.22874 1 3.33331V8.66665C1 9.77122 1.89543 10.6666 3 10.6666Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
